
export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-emerald-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              LACOSBEL
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              자연의 치유력과 과학의 정밀함이 만나, 피부와 마음이 함께 빛나는 아름다움을 만듭니다.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-facebook-fill text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-instagram-line text-xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-youtube-line text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">빠른 링크</h4>
            <ul className="space-y-2">
              <li><a href="#about" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">회사소개</a></li>
              <li><a href="#products" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">제품</a></li>
              <li><a href="#brands" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">브랜드</a></li>
              <li><a href="/board" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">게시판</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">연락처</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">연락처</h4>
            <div className="space-y-2 text-gray-300">
              <p className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line"></i>
                </div>
                대표: 02-412-0315
              </p>
              <p className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-customer-service-line"></i>
                </div>
                고객센터: 02-412-0318
              </p>
              <p className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-mail-line"></i>
                </div>
                lacosbell@naver.com
              </p>
              <p className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-2 mt-0.5">
                  <i className="ri-map-pin-line"></i>
                </div>
                서울 송파구 석촌호수로 284,<br />5층 511호 (송파동,현대레이크빌)
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 라코스벨. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
